import React, {useState, useEffect} from 'react';

import ModalSuccess from "./modals/ModalSuccess";
import ModalLogin from "./modals/ModalLogin";
import ModalSignUp from "./modals/ModalSign";
import ModalRestore from "./modals/ModalRestore";
import connect from 'react-redux/es/connect/connect';
import PropTypes from "prop-types";

function EnterPage({isLoaded, isError}){
    const [isOpenLogin, setOpenLogin] = useState(false);
    const [isOpenSign, setOpenSign] = useState(false);
    const [isOpenSuccess, setOpenSuccess] = useState(false);
    const [isOpenRestore, setOpenRestore] = useState(false);
    const [successText, setSuccessText] = useState('');
    const [isMounted, setMounted] = useState(false);

    useEffect(() => {
        if (!isMounted) {
            setMounted(true);
            document.title = 'Faces'
        }
    });


    function toggleModalLogin() { setOpenLogin(!isOpenLogin);}
    const toggleModalSign = () => setOpenSign(!isOpenSign);
    const toggleModalSuccess = () => setOpenSuccess(!isOpenSuccess);
    const toggleModalRestore = () => setOpenRestore(!isOpenRestore);


    return (
        <div className="app">
            <div className={"container-login"}>
                <div className="wrap-login">
                    <div className="welcome padding-bottom-50">
                        <img src="./Faces%20Icon.png" className='logo' alt=""/>
                    </div>
                    <div className="wrap-buttons">
                        <button className="btn first width100" onClick={toggleModalSign}>Sign up</button>
                        <button className="btn third width100" onClick={toggleModalLogin}>Log In</button>
                    </div>
                </div>

                <ModalSignUp isOpen={isOpenSign}
                             toggle={toggleModalSign}
                             setSuccessText={setSuccessText}
                             toggleSuccess={toggleModalSuccess}
                             isLoaded={isLoaded}
                             isError={isError}
                />
                <ModalLogin isOpen={isOpenLogin}
                            toggleRestore={toggleModalRestore}
                            toggle={toggleModalLogin}
                            setSuccessText={setSuccessText}
                            toggleSuccess={toggleModalSuccess}
                            isLoaded={isLoaded}
                            isError={isError}
                />
                <ModalRestore isOpen={isOpenRestore}
                              toggle={toggleModalRestore}
                              setSuccessText={setSuccessText}
                              toggleSuccess={toggleModalSuccess}
                              isLoaded={isLoaded}
                              isError={isError}
                />
                <ModalSuccess isOpen={isOpenSuccess}
                              successText={successText}
                              toggle={toggleModalSuccess}
                />

            </div>
        </div>
    );
}

EnterPage.propTypes = {
    isLoaded: PropTypes.bool,
    isError: PropTypes.bool,
};

export default connect(state => {
    const {
        profile: {
            isFetching,
            isError,
        },
    } = state;

    return {
        isLoaded: isFetching,
        isError,
    };
})(EnterPage);
